import React from "react";
import styles from "./Skeleton.module.css";

const Skeleton = ({
  width = "100%",
  height = "12px",
  radius = "6px",
  className = "",
  style = {},
}) => {
  return (
    <span
      className={`${styles.skeleton} ${className}`}
      style={{ width, height, borderRadius: radius, ...style }}
    />
  );
};

export const SkeletonBarGroup = ({
  count = 4,
  heights = [],
  className = "",
  barClassName = "",
}) => {
  const barHeights = heights.length > 0 ? heights : Array.from({ length: count }, (_, index) => `${40 + index * 10}%`);

  return (
    <div className={`${styles.barGroup} ${className}`}>
      {Array.from({ length: count }).map((_, index) => (
        <span
          key={`skeleton-bar-${index}`}
          className={`${styles.bar} ${barClassName}`}
          style={{ height: barHeights[index % barHeights.length] }}
        />
      ))}
    </div>
  );
};

export default Skeleton;



